import { Schema } from '@effect/schema'
import { OnboardingCustomerInformationInput } from '@marketplace/functions/src/schema/onboarding/customer-information'

export const parseCustomerInformation = Schema.decodeUnknown(OnboardingCustomerInformationInput)
export const encodeCustomerInformation = Schema.encode(OnboardingCustomerInformationInput)
